import { useState, useEffect } from 'react';
import './captcha.css';
import { toAbsoluteUrl } from '../../_metronic/helpers';
import request from '../../utils/request';

function Captcha({ setCaptchaText, setCaptchaToken }) {
	const [captchaImageUrl, setCaptchaImageUrl] = useState('');

	useEffect(() => {
		initializeCaptcha();
	}, []);

	const generateCaptchaText = async () => {
		await request.get('/Users/GetCaptcha').then((res) => {
			if (res.status === 200 || res.status === 201) {
				let newMethodImage = res?.data?.dntCaptchaImgUrl?.replace("DNTCaptchaImage/Show", "api/Users/ShowCaptcha") || "";
				newMethodImage += `&check=${res.data.dntCaptchaTextValue}`;
				setCaptchaImageUrl(newMethodImage);
				setCaptchaText(res.data.dntCaptchaTextValue);
				setCaptchaToken(res.data.dntCaptchaTokenValue);
			}
		});
	};

	const initializeCaptcha = () => {
		generateCaptchaText();
	};

	return (
		<div>
			<div id="wrapper-ca">
				<img
					style={{marginTop: "4px"}}
					width={200}
					height={42}
					src={captchaImageUrl}
					alt="captcha-image"
				/>
				<div id="reload-button-ca" onClick={() => initializeCaptcha()}>
					<img
						className="mx-auto"
						style={{ width: '50px', height: '50px' }}
						src={toAbsoluteUrl('/media/pgn/pgn_arrow.png')}
						alt=""
					/>
				</div>
			</div>
		</div>
	);
}

export default Captcha;
